const selectors = {
    readMoreBtn: document.querySelectorAll('[data-more-btn]'),
    alphaEls: document.querySelectorAll('[data-alpha]')
  };
  class templateCollectionJS {
    constructor() {
      if(selectors.alphaEls.length > 0) {
        console.log('l---letter');
        this.alphaFilter();
      } else {
        this.readMore();
        this.readMoreCollection();
      }
    }

    readMoreCollection(){

        if(document.querySelector('[data-view-collections]') != null){
          document.querySelector('[data-view-collections]').addEventListener('click', (e) => {
              e.preventDefault();
              let currentTarget = e.target;
              if(currentTarget.closest('[data-sub-collections]').classList.contains('open')){
                currentTarget.closest('[data-sub-collections]').classList.remove('open');
                currentTarget.closest('[data-view-collections]').querySelector('[data-read-more]').classList.remove('d-none');
                currentTarget.closest('[data-view-collections]').querySelector('[data-read-less]').classList.add('d-none');
              }else{
                currentTarget.closest('[data-sub-collections]').classList.add('open');
                currentTarget.closest('[data-view-collections]').querySelector('[data-read-more]').classList.add('d-none');
                currentTarget.closest('[data-view-collections]').querySelector('[data-read-less]').classList.remove('d-none');
              }
          });
        }
    }
    
    // Read More and Read Less
    readMore(){
        selectors.readMoreBtn.forEach(element => {
          if(element){
            let contentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('[data-rte]').scrollHeight;
            let newContentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('[data-rte]').offsetHeight;
  
            if (contentBlockHeight == newContentBlockHeight){
              element.closest('[data-readmorecontainer]').querySelector('[data-rte]').style.height = 'auto';
              element.classList.add('d-none');
               element.classList.remove('d-inline-block');
            }
            element.addEventListener('click', (e)=> {
              e.preventDefault();
              let currentTarget = e.target;
              if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').querySelector('[data-rte]').style.height = '';
                }, 1);
                currentTarget.closest('[data-readmorecontainer]').classList.remove('open');
                element.querySelector('[data-readmore]').classList.toggle('d-none');
                element.querySelector('[data-readless]').classList.toggle('d-none');
              } else {
                currentTarget.closest('[data-readmorecontainer]').querySelector('[data-rte]').style.height = newContentBlockHeight + 'px';
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').querySelector('[data-rte]').style.height = contentBlockHeight + 'px';
                }, 1);
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').classList.add('open');
                }, 300);
                element.querySelector('[data-readmore]').classList.toggle('d-none');
                element.querySelector('[data-readless]').classList.toggle('d-none');
              }
  
            });
          }
        });
    }

    alphaFilter(){
      document.querySelectorAll('[data-alpha]').forEach( x => {
        x.addEventListener('click',(e) => {
          console.log('l---letter');
            document.querySelectorAll('[data-alpha]').forEach( d => {
                d.classList.remove('active');
            });
            e.currentTarget.classList.add('active');
            document.querySelector('[data-no-letter]').classList.add('d-none');
            let letter = e.target.getAttribute('data-alpha');
            console.log(letter,'---letter');
            if(letter == '#'){
                document.querySelectorAll('[data-letter]').forEach(y => {
                    y.classList.remove('d-none');
                });
            } else {
                if(document.querySelectorAll(`[data-letter="${letter}"]`).length == 0){
                    document.querySelector('[data-no-letter]').classList.remove('d-none');
                    document.querySelectorAll('[data-letter]').forEach(y => {
                        y.classList.add('d-none');
                    });
                } else {
                    document.querySelectorAll('[data-letter]').forEach(y => {
                        if(y.getAttribute('data-letter') != letter)
                            y.classList.add('d-none');
                        else
                            y.classList.remove('d-none');
                    });
                }
            }             
        });
      });
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 